import { render, staticRenderFns } from "./irrigation-list.html?vue&type=template&id=e2c37548&scoped=true&"
import script from "./irrigation-list.js?vue&type=script&lang=js&"
export * from "./irrigation-list.js?vue&type=script&lang=js&"
import style0 from "./IrrigationList.vue?vue&type=style&index=0&id=e2c37548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c37548",
  null
  
)

component.options.__file = "IrrigationList.vue"
export default component.exports